import { ContentWrapper3n9gdymgnbto9 as ContentWrapper } from '../../../../../../ktor-ktor-http/io/ktor/http/content/OutgoingContent.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var SSEClientContentClass;
function SSEClientContent() {
  if (SSEClientContentClass === VOID) {
    class $ extends ContentWrapper() {}
    initMetadataForClass($, 'SSEClientContent');
    SSEClientContentClass = $;
  }
  return SSEClientContentClass;
}
//region block: exports
export {
  SSEClientContent as SSEClientContent14bbfeddoyr65,
};
//endregion

//# sourceMappingURL=SSEClientContent.mjs.map
